module.exports = __webpack_public_path__ + "static/00011.08524bbd.jpg";